<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper achievementNotifications" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="achievementNotification">
				<div class="backgroundFlare rotate">
					<div class="flareRay" v-for="n in (1, 12)"></div>
				</div>
				<div class="wrapper">
					<div class="backgroundTop achievement_scrollTop_layout modalDecoration msAntiScroll">
						<i class="close action_cancel_small_flat_black clickable" @click="onModalClose(close)"></i>
					</div>
					<div class="backgroundMiddle modalContent scrollable">
						<div class="scrollContentOuterWrapper" style="width: 369px;">
							<div class="scrollContent" style="width: 369px; overflow-y: auto; max-height: 617px;">
								<div class="scrollContentInnerWrapper" style="width: auto;">
									<b><span>Получено достижение!</span></b>
									<div class="divider"></div>
									<div class="clear"></div>
									<div class="achievement" v-for="notification in achievementNotifications">
										<div class="achievementIconWrapper">
											<i class="achievementFrame" :class="['achievements_'+notification.frame+'_huge_illu']"></i>
											<i class="achievementIcon" :class="['achievements_'+notification.icon+'_large_illu']"></i>
										</div>
										<div class="contentBoxHeader headerWithArrowEndings glorious gold">
											<div class="content">
												<b>+{{notification.prestige}}</b>
												<span>&nbsp;</span>
												<i class="feature_prestige_small_flat_black"></i>
											</div>
										</div>
										<span class="achievementName"><span>{{notification.name}}</span></span>
										<div class="clear"></div>
										<span class="achievementDescription">
											<span>{{notification.description}}</span>
										</span>
										<div class="divider"></div>
									</div>
									<button class="collectRewardsButton clickable" @click="onModalClose(close)">
										<div class="content">
											<span class="innerText">
												<span>Забрать награду</span>
												<span>&nbsp;</span>
												<i class="action_leave_small_flat_white"></i>
											</span>
											<div class="animationOverlay"></div>
											<i class="checkmark action_check_small_flat_white"></i>
											<i class="checkmark action_check_small_flat_black"></i>
											<i class="checkmark action_check_small_flat_red"></i>
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="achievement_scrollBottom_layout"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
		
		achievementNotifications: [
			{
				name: 'Чистый лист',
				description: 'Ничего не найти в приключениях следующее количество раз: 1.',
				frame: 'frame1',
				icon: 'type118',
				prestige: 1,
			},
			{
				name: 'Великий зодчий',
				description: 'Закончить игровой мир в топ 50% (в рейтинге деревень).',
				frame: 'frame1',
				icon: 'type47',
				prestige: 1,
			},
			{
				name: 'Ветеран Travian Kingdoms',
				description: 'Завершить не менее 1 игровых миров.',
				frame: 'frame1',
				icon: 'type49',
				prestige: 2,
			},
			{
				name: 'До конца! (#4 с BeHappy на RU4)',
				description: 'Ты завершил раунд на RU4 и достиг 4 ранга с королевством BeHappy в октября 2020.',
				frame: 'frameMystery',
				icon: 'type63',
				prestige: 5,
			},
			{
				name: 'Безусловный лидер',
				description: 'Закончить игровой мир в топ 50% (по очкам победы).',
				frame: 'frame1',
				icon: 'type43',
				prestige: 2,
			},
		],
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>